/**
 *
 * @param {string} year
 * @param {string} month
 * @param {TFunction<"translation", undefined>} t
 * @returns {*[]}
 */
export function getDaysArray(year, month, t) {
  let monthIndex = month - 1
  let names = [t('times.sun'), t('times.mon'), t('times.tue'), t('times.wed'), t('times.thu'), t('times.fri'), t('times.sat')]
  let date = new Date(year, monthIndex, 1)
  let result = []
  while (date.getMonth() === monthIndex) {
    result.push({
      data: `${date.getDate()}${names[date.getDay()]}`,
      attribute: `${date.getDate()}`
    })
    date.setDate(date.getDate() + 1)
  }
  return result
}
